import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {registerPrivacyServiceWorker} from './utils/registerPrivacyServiceWorker';
import {removeLegacyPublicOrganizationCaches} from './utils/removeLegacyOrganizationCaches';

removeLegacyPublicOrganizationCaches();
// Track edits before the load event/service-worker registration can occur.
for (const type of ["input", "change"]) document.addEventListener(type, () => {
  window.__lightlyHasEnteredInformation = true;
}, {capture: true});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => registerPrivacyServiceWorker());
}
